import { render, staticRenderFns } from "./SocialBookingSlots.vue?vue&type=template&id=04b79375&"
import script from "./SocialBookingSlots.vue?vue&type=script&lang=js&"
export * from "./SocialBookingSlots.vue?vue&type=script&lang=js&"
import style0 from "./SocialBookingSlots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports